import React from 'react';
import clsx from 'clsx';
import { FormattedMessage } from 'react-intl';

const ValidationSpan = ({ validationError, position = 'right', errorCoordinate }) => {
  if (!validationError) {
    return null;
  }
  const { message } = validationError;

  if (validationError.translation?.on) {
    return (
      <span className={clsx('validation-error', `validation-error--${position}`, errorCoordinate)}>
        <FormattedMessage id={message} values={validationError.translation.messageArgs || {}} />
      </span>
    );
  }

  return (
    <span className={clsx('validation-error', `validation-error--${position}`, errorCoordinate)}>
      {message}
    </span>
  );
};

export default ValidationSpan;
